// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreCheckoutShippingState, {
    CarrierInfoModel,
} from "@store/Framework/Store/Store/Pages/CheckoutShipping/CheckoutShippingState";
import { Draft } from "immer";

const initialState: StoreCheckoutShippingState = {
    carrierInfo: undefined,
    saveAddress: false,
};

const actions = {
    "Store/Pages/CheckoutShipping/SetCarrierInfo": (
        draft: Draft<StoreCheckoutShippingState>,
        action: { carrierInfo: CarrierInfoModel },
    ) => {
        draft.carrierInfo = action.carrierInfo;
    },
    "Store/Pages/CheckoutShipping/SetSaveAddress": (
        draft: Draft<StoreCheckoutShippingState>,
        action: { saveAddress: boolean },
    ) => {
        draft.saveAddress = action.saveAddress;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreCheckoutShippingActions = Parameters<typeof reducer>[1];
export default reducer;
